export const version = '0.1';
export const navbarBreakPoint = 'xl'; // Vertical navbar breakpoint
export const topNavbarBreakpoint = 'lg';
export const settings = {
  isFluid: true,
  isRTL: false,
  isDark: false,
  navbarPosition: 'vertical',
  showBurgerMenu: true, // controls showing vertical nav on mobile
  currency: '$',
  isNavbarVerticalCollapsed: true, // toggle vertical navbar collapse
  navbarStyle: 'transparent' // navbar style
};

export default { version, navbarBreakPoint, topNavbarBreakpoint, settings };
